import postLogin from "./postLogin";
import postMembro from "./postMembro";

type Login = {
  nome: string;
  cpf: string;
  email: string;
  senha: string;
};
type Membro = {
  rg: string;
  orgao: string;
  cargo: string;
  endereco: {
    cep: string;
    cidade: string;
    estado: string;
    bairro: string;
    rua: string;
    numero: string;
    complemento?: string;
  };
  data_inicio_mandato?: Date | undefined;
  data_fim_mandato?: Date | undefined;
};

const registrarNovoMembro = async (
  token: string,
  dadosLogin: Login,
  dadosMembro: Membro,
  id_instituicao: number
) => {
  const userCredential = await postLogin(
    dadosLogin.nome,
    dadosLogin.cpf.replace(/\D/g, ""),
    dadosLogin.email,
    dadosLogin.senha
  )
    .then(async (userCredential) => {
      return userCredential;
    })
    .catch((err) => {
      const { code, message } = err;
      console.log("Erro ao criar novo login");
      console.log(code, message);
    });

  if (!userCredential) {
    throw new Error("erro registra usuário");
  }

  const memberCredential = await postMembro(
    token,
    dadosMembro.rg,
    dadosMembro.orgao,
    dadosMembro.cargo,
    dadosMembro.endereco.cep,
    dadosMembro.endereco.cidade,
    dadosMembro.endereco.estado,
    dadosMembro.endereco.rua,
    dadosMembro.endereco.bairro,
    dadosMembro.endereco.numero,
    dadosMembro.data_inicio_mandato?.toISOString().split("T")[0],
    dadosMembro.data_fim_mandato?.toISOString().split("T")[0],
    true,
    userCredential.id,
    id_instituicao,
    dadosMembro.endereco.complemento
  )
    .then(async (memberCredential) => {
      return memberCredential;
    })
    .catch((err) => {
      const { code, message } = err;
      console.log("Erro ao criar novo login");
      console.log(code, message);
    });
  if (!memberCredential) {
    throw new Error("erro registra membro");
  }
  return {
    userCredential,
    memberCredential,
  };
};
export default registrarNovoMembro;
